// extracted by mini-css-extract-plugin
module.exports = {"root":"GoogleApplePayModal_root__KztDj","btn":"GoogleApplePayModal_btn__2w0F1","spinningIcon":"GoogleApplePayModal_spinningIcon__v7Agm"};